/**
 * @file: useServiceAgentList.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import {
  useCurrentStoreId,
  useCurrentUserId,
} from '@euler/app/flows/auth/context';
import { OrgMember } from '@euler/model/entity';
import { useServiceFactory } from '@euler/services/factory';
import { useConditionalAsyncResource } from '@euler/utils/hooks';
import { useCallback } from 'react';

export const useServiceAgentList = (initialValues?: OrgMember[] | null) => {
  const { storeService } = useServiceFactory();
  const userId = useCurrentUserId();

  const fetch = useCallback(
    () =>
      storeService.listServiceAgents().then(res => {
        const current = res.find(member => member.userId === userId);
        return current
          ? [current, ...res.filter(member => member.userId !== userId)]
          : res;
      }),
    [storeService, userId],
  );
  const storeId = useCurrentStoreId()!;
  return useConditionalAsyncResource(
    fetch,
    storeId ? `store/${storeId}/service-agents` : null,
    initialValues,
    { autoClear: true },
  );
};
